import { ISVG } from "./UrlIcon";

export interface IDownloadingIconProps extends ISVG {}

export const DownloadingIcon = ({
    width,
    height,
    fill,
}: IDownloadingIconProps) => {
    const _width = width ?? 41;
    const _height = height ?? 36;
    const _fill = fill ?? "white";

    return (
        <svg
            width={_width}
            height={_height}
            viewBox="0 0 41 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1380_10412)">
                <path
                    d="M24.0925 21.6241H21.5663V13.3636C21.5663 13.2136 21.4436 13.0908 21.2936 13.0908H19.248C19.098 13.0908 18.9753 13.2136 18.9753 13.3636V21.6241H16.4559C16.2275 21.6241 16.1013 21.8867 16.2411 22.0639L20.0594 26.8948C20.085 26.9274 20.1176 26.9538 20.1548 26.9719C20.192 26.9901 20.2328 26.9995 20.2742 26.9995C20.3156 26.9995 20.3565 26.9901 20.3937 26.9719C20.4309 26.9538 20.4635 26.9274 20.489 26.8948L24.3073 22.0639C24.4471 21.8867 24.321 21.6241 24.0925 21.6241Z"
                    fill={_fill}
                />
            </g>
            <g filter="url(#filter1_d_1380_10412)">
                <path
                    d="M30.4807 10.0469C28.9192 5.92854 24.9406 3 20.2802 3C15.6198 3 11.6412 5.92513 10.0798 10.0435C7.15805 10.8106 5 13.4732 5 16.637C5 20.4042 8.05127 23.4554 11.8151 23.4554H13.1822C13.3322 23.4554 13.4549 23.3327 13.4549 23.1827V21.1372C13.4549 20.9871 13.3322 20.8644 13.1822 20.8644H11.8151C10.6662 20.8644 9.58543 20.4076 8.78085 19.5791C7.97967 18.7541 7.55352 17.6427 7.59102 16.4904C7.6217 15.5903 7.92854 14.7448 8.48424 14.0323C9.05359 13.3061 9.85135 12.7777 10.7377 12.5425L12.0299 12.2049L12.5037 10.9572C12.7969 10.1799 13.206 9.45369 13.7208 8.79571C14.2291 8.14355 14.8311 7.57026 15.5073 7.0945C16.9085 6.10923 18.5585 5.58761 20.2802 5.58761C22.0019 5.58761 23.6519 6.10923 25.0531 7.0945C25.7316 7.57179 26.3316 8.14454 26.8396 8.79571C27.3544 9.45369 27.7635 10.1833 28.0567 10.9572L28.5272 12.2015L29.8159 12.5425C31.6637 13.0402 32.9558 14.721 32.9558 16.637C32.9558 17.7654 32.516 18.8291 31.7182 19.6269C31.327 20.0204 30.8616 20.3324 30.3489 20.5448C29.8363 20.7572 29.2866 20.8659 28.7317 20.8644H27.3646C27.2146 20.8644 27.0919 20.9871 27.0919 21.1372V23.1827C27.0919 23.3327 27.2146 23.4554 27.3646 23.4554H28.7317C32.4955 23.4554 35.5468 20.4042 35.5468 16.637C35.5468 13.4766 33.3956 10.8174 30.4807 10.0469Z"
                    fill={_fill}
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1380_10412"
                    x="11.1826"
                    y="12.0908"
                    width="18.1836"
                    height="23.9082"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1380_10412"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1380_10412"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_1380_10412"
                    x="0"
                    y="0"
                    width="40.5469"
                    height="30.4551"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1380_10412"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1380_10412"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};
